import { replace } from 'react-router-redux';
import { put, fork, takeEvery, all } from 'redux-saga/effects';
import { get } from 'lodash';

import { showNotification } from 'modules/snackbar';
import { FETCH_ENGINE_SUCCESS } from 'modules/engine';

// ***
// Permissions checks for engine
// ***
function* onEngineLoadFailure(action, resource) {
  if (!action.payload.errors) {
    return;
  }

  const message = {
    not_found: `The specified ${resource} was not found.`,
    default: `The specified ${resource} was not found.`
  }[get(action.payload, 'errors[0].name', 'default')];

  yield put(showNotification(message));
  yield put(replace(`/${resource}s`));
}

function* watchEnginePermissions() {
  yield takeEvery(FETCH_ENGINE_SUCCESS, onEngineLoadFailure);
}

export default function* root({ route: { resource } }) {
  yield all([
    // when the details page is loaded, make sure user has permissions
    // to view the specified engine, and that it exists
    fork(watchEnginePermissions, resource)
  ]);
}



// WEBPACK FOOTER //
// ./src/client/plugins/automate-studio/modules/details-sagas.js